import React, { useState, useEffect } from 'react';
import { Grid, TextField } from '@mui/material'
import Select from 'react-select';
import axios from 'axios';
import Searchcategory from '../Home/HomeSearch/Searchcategory';
import ReactQuill from 'react-quill';
import "react-quill/dist/quill.snow.css";
import { jwtDecode } from 'jwt-decode'; // Corrected import
import { Constants } from '../../endPoints';

export default function Addproduct() {
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [content, setContent] = useState('');
  const [selections, setSelections] = useState([]);
  const [categories, setCategories] = useState([]);
  const [shopForOptions, setShopForOptions] = useState([]);
  const [selectedSelection, setSelectedSelection] = useState(null); // New state to hold selected selection
  const [isSelectionLoading, setIsSelectionLoading] = useState(false);
  const [isCategoriesLoading, setIsCategoriesLoading] = useState(false);
  const [isShopForLoading, setIsShopForLoading] = useState(false);
  const [loading, setLoading] = useState(false);


  const [ringStyles, setRingStyles] = useState([]);
  const [isRingStylesLoading, setIsRingStylesLoading] = useState(false);

  const [clarityOptions, setClarityOptions] = useState([]);
  const [isClarityLoading, setIsClarityLoading] = useState(false);

  const [stoneColors, setStoneColors] = useState([]);
  const [isStoneColorsLoading, setIsStoneColorsLoading] = useState(false);

  const [pearlColors, setPearlColors] = useState([]);
  const [isPearlColorsLoading, setIsPearlColorsLoading] = useState(false);

  const [pearlTypes, setPearlTypes] = useState([]);
  const [isPearlTypesLoading, setIsPearlTypesLoading] = useState(false);

  const [diamondColors, setDiamondColors] = useState([]);
  const [isDiamondColorsLoading, setIsDiamondColorsLoading] = useState(false);

  const [imagePreviews, setImagePreviews] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);

  const [feedbackMessage, setFeedbackMessage] = useState('');
  const [feedbackType, setFeedbackType] = useState('');
  const [resetKey, setResetKey] = useState(0);



  // Fetch countries
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axios.get(`${Constants.listCounty}`);
        setCountries(response.data.data);
      } catch (error) {
        console.error('Error fetching countries:', error);
      }
    };
    fetchCountries();
  }, []);

  useEffect(() => {
    if (feedbackMessage) {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  }, [feedbackMessage]);

  const fetchStates = async (countryId) => {
    const accessToken = localStorage.getItem('authToken');
    try {
      const response = await axios.get(`${Constants.getStatecountryById}/${countryId}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      setStates(response.data.data);
      setCities([]); // Clear cities when country changes
    } catch (error) {
      console.error('Error fetching states:', error);
    }
  };

  const fetchCities = async (stateId) => {
    const accessToken = localStorage.getItem('authToken');
    try {
      const response = await axios.get(`${Constants.getCityStateById}/${stateId}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      setCities(response.data.data);
    } catch (error) {
      console.error('Error fetching cities:', error);
    }
  };

  useEffect(() => {
    const fetchSelections = async () => {
      setIsSelectionLoading(true);
      try {
        const response = await axios.get(Constants.listSelection);
        if (response.data.status === 1) {
          setSelections(response.data.list);
        }
      } catch (error) {
        console.error('Error fetching selections:', error);
      } finally {
        setIsSelectionLoading(false);
      }
    };

    fetchSelections();
  }, []);

  useEffect(() => {
    const fetchCategories = async () => {
      setIsCategoriesLoading(true);
      try {
        const response = await axios.get(Constants.listCategory);
        if (response.data.status === 1) {
          setCategories(response.data.list);
        }
      } catch (error) {
        console.error('Error fetching categories:', error);
      } finally {
        setIsCategoriesLoading(false);
      }
    };

    fetchCategories();
  }, []);

  useEffect(() => {
    const fetchShopForOptions = async () => {
      setIsShopForLoading(true);
      try {
        const response = await axios.get(Constants.listShopFor);
        if (response.data.status === 1) {
          setShopForOptions(response.data.list);
        }
      } catch (error) {
        console.error('Error fetching shopFor options:', error);
      } finally {
        setIsShopForLoading(false);
      }
    };

    fetchShopForOptions();
  }, []);


  useEffect(() => {
    const fetchRingStyles = async () => {
      setIsRingStylesLoading(true);
      try {
        const response = await axios.get(Constants.listRingStyle);
        if (response.data.status === 1) {
          setRingStyles(response.data.list); // Set ring styles options
        }
      } catch (error) {
        console.error('Error fetching ring styles:', error);
      } finally {
        setIsRingStylesLoading(false);
      }
    };

    fetchRingStyles();
  }, []);

  useEffect(() => {
    const fetchClarityOptions = async () => {
      setIsClarityLoading(true);
      try {
        const response = await axios.get(Constants.listClarity);
        if (response.data.status === 1) {
          setClarityOptions(response.data.list); // Set clarity options
        }
      } catch (error) {
        console.error('Error fetching clarity options:', error);
      } finally {
        setIsClarityLoading(false);
      }
    };

    fetchClarityOptions();
  }, []);

  useEffect(() => {
    const fetchStoneColors = async () => {
      setIsStoneColorsLoading(true);
      try {
        const response = await axios.get(Constants.listStoneColor);
        if (response.data.status === 1) {
          setStoneColors(response.data.list); // Set stone color options
        }
      } catch (error) {
        console.error('Error fetching stone colors:', error);
      } finally {
        setIsStoneColorsLoading(false);
      }
    };

    fetchStoneColors();
  }, []);

  useEffect(() => {
    const fetchPearlColors = async () => {
      setIsPearlColorsLoading(true);
      try {
        const response = await axios.get(Constants.listPearlColor);
        if (response.data.status === 1) {
          setPearlColors(response.data.list); // Set pearl color options
        }
      } catch (error) {
        console.error('Error fetching pearl colors:', error);
      } finally {
        setIsPearlColorsLoading(false);
      }
    };

    fetchPearlColors();
  }, []);

  useEffect(() => {
    const fetchPearlTypes = async () => {
      setIsPearlTypesLoading(true);
      try {
        const response = await axios.get(Constants.listPearlType);
        if (response.data.status === 1) {
          setPearlTypes(response.data.list); // Set pearl type options
        }
      } catch (error) {
        console.error('Error fetching pearl types:', error);
      } finally {
        setIsPearlTypesLoading(false);
      }
    };

    fetchPearlTypes();
  }, []);

  useEffect(() => {
    const fetchDiamondColors = async () => {
      setIsDiamondColorsLoading(true);
      try {
        const response = await axios.get(Constants.listDiamondColor);
        if (response.data.status === 1) {
          setDiamondColors(response.data.list); // Set diamond color options
        }
      } catch (error) {
        console.error('Error fetching diamond colors:', error);
      } finally {
        setIsDiamondColorsLoading(false);
      }
    };

    fetchDiamondColors();
  }, []);


  const handleChange = (value) => {
    setContent(value);
  };



  const countryOptions = countries.map(country => ({
    value: country.id,
    label: country.country, // ✅ text for search
    image: country.country_symbols // ✅ keep flag
  }));

  // const stateOptions = states.map(state => ({ value: state.id, label: state.name }));
  const stateOptions = states
    .sort((a, b) => a.name.localeCompare(b.name)) // ✅ sort ascending
    .map(state => ({
      value: state.id,
      label: state.name
    }));
  const cityOptions = cities.map(city => ({ value: city.id, label: city.name }));

  // const selectionOptions = selections.map((selection) => ({
  //   value: selection.id,
  //   label: (
  //     <div style={{ display: 'flex', alignItems: 'center' }}>
  //       <img
  //         src={`${Constants.imageBaseURL}/${selection.image}`} // Assuming `imageBaseURL` is the base URL for images
  //         alt={selection.name}
  //         style={{ width: '20px', marginRight: '10px' }}
  //       />
  //       {selection.name}
  //     </div>
  //   ),
  // }));

  const selectionOptions = selections.map((selection) => ({
    value: selection.id,
    label: selection.name, // ✅ text only
    image: `${Constants.imageBaseURL}/${selection.image}` // ✅ keep image
  }));

  // const categoryOptions = categories.map((category) => ({
  //   value: category.id,
  //   label: (
  //     <div style={{ display: 'flex', alignItems: 'center' }}>
  //       <img
  //         src={`${Constants.imageBaseURL}/${category.image}`} // Assuming `imageBaseURL` is the base URL for images
  //         alt={category.name}
  //         style={{ width: '20px', marginRight: '10px' }}
  //       />
  //       {category.name}
  //     </div>
  //   ),
  // }));

  const categoryOptions = categories.map((category) => ({
    value: category.id,
    label: category.name, // ✅ text only
    image: `${Constants.imageBaseURL}/${category.image}` // ✅ keep image
  }));

  const shopForOptionsMapped = shopForOptions.map((shopFor) => ({
    value: shopFor.id,
    label: shopFor.name,
  }));

  const ringStyleOptionsMapped = ringStyles.map((ringStyle) => ({
    value: ringStyle.id,
    label: ringStyle.name,
  }));

  const stoneColorOptionsMapped = stoneColors.map((stoneColor) => ({
    value: stoneColor.id,
    label: stoneColor.name,
  }));

  const diamondColorOptionsMapped = diamondColors.map((diamondColor) => ({
    value: diamondColor.id,
    label: diamondColor.name,
  }));

  const clarityOptionsMapped = clarityOptions.map((clarity) => ({
    value: clarity.id,
    label: clarity.name,
  }));

  const pearlColorOptionsMapped = pearlColors.map((pearlColor) => ({
    value: pearlColor.id,
    label: pearlColor.name,
  }));

  const pearlTypeOptionsMapped = pearlTypes.map((pearlType) => ({
    value: pearlType.id,
    label: pearlType.name,
  }));

  const handleFileChange = (e) => {
    const files = e.target.files;
    const filesArray = Array.from(files);

    // Create blob URLs for image previews
    const previews = filesArray.map(file => URL.createObjectURL(file));

    setImagePreviews((prevPreviews) => [...prevPreviews, ...previews]);  // Append new previews
    setSelectedFiles((prevFiles) => [...prevFiles, ...filesArray]);  // Append new files
  };

  const [formData, setFormData] = useState({
    country: '',
    state: '',
    city: '',
    selection: '',
    category: '',
    shopFor: '',
    ringStyle: '',
    stoneColor: '',
    diamondColor: '',
    clarity: '',
    pearlColor: '',
    pearlType: '',
    description: '',
    price: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleRemoveImage = (indexToRemove) => {
    setImagePreviews((prev) => prev.filter((_, i) => i !== indexToRemove));
    setSelectedFiles((prev) => prev.filter((_, i) => i !== indexToRemove));
  };

  const validateForm = () => {
    if (!formData.country) return "Country is required";
    if (!formData.state) return "State is required";
    if (!formData.city) return "City is required";
    if (!formData.selection) return "Main Selection is required";

    // Category required only for some selections
    if ([1, 2, 3, 4, 5, 8].includes(selectedSelection) && !formData.category) {
      return "Category is required";
    }

    if (!formData.shopFor) return "Shop For is required";

    if (!content || content.trim() === "") return "Description is required";

    if (selectedFiles.length === 0) return "At least one product image is required";

    return null;
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    const error = validateForm();
    if (error) {
      setFeedbackMessage(error);
      setFeedbackType("error");
      return; // ❌ STOP SUBMIT
    }
    const accessToken = localStorage.getItem('authToken');
    const formDataToSubmit = new FormData();
    if (!accessToken) {
      console.error('No access token found');
      return;
    }
    const decodedToken = jwtDecode(accessToken);
    // Assuming the user ID is stored as 'id' in the decoded token
    const idUser = decodedToken.id;
    formDataToSubmit.append('idUser', idUser);
    formDataToSubmit.append('idCountry', formData.country);
    formDataToSubmit.append('idState', formData.state);
    formDataToSubmit.append('idCity', formData.city);
    formDataToSubmit.append('idSelection', formData.selection);
    formDataToSubmit.append('idCategory', formData.category);
    formDataToSubmit.append('idShopFor', formData.shopFor);
    formDataToSubmit.append('idRingStyle', formData.ringStyle);
    formDataToSubmit.append('idStoneColor', formData.stoneColor);
    formDataToSubmit.append('idDiamondColor', formData.diamondColor);
    formDataToSubmit.append('idClarity', formData.clarity);
    formDataToSubmit.append('idPearlColor', formData.pearlColor);
    formDataToSubmit.append('idPearlType', formData.pearlType);
    formDataToSubmit.append('description', content);
    if (selectedFiles.length > 0) {
      selectedFiles.forEach((file) => {
        formDataToSubmit.append('images', file); // Append each file to the FormData
      });
    }
    try {
      setLoading(true);
      const response = await axios.post(`${Constants.addProduct}`, formDataToSubmit, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'multipart/form-data',
        },
      });
      if (response.data.success === 1) {
        setFeedbackMessage('Product added successfully. It is currently under review by the admin.');
        setFeedbackType('success'); // Set feedback type to success

        // Reset the form data
        setFormData({
          country: '',
          state: '',
          city: '',
          selection: '',
          category: '',
          shopFor: '',
          ringStyle: '',
          stoneColor: '',
          diamondColor: '',
          clarity: '',
          pearlColor: '',
          pearlType: '',
          description: '',
          price: ''
        });
        setContent('');
        // Clear selected files
        setSelectedFiles([]);
        setImagePreviews([]);
        setSelectedSelection('');
        if (document.getElementById('fileInput')) {
          document.getElementById('fileInput').value = ''; // Clear the file input field
        }
        setResetKey(prevKey => prevKey + 1);
        setLoading(false);
      } else {
        setFeedbackMessage('Failed to create product.');
        setFeedbackType('error'); // Set feedback type to error
        setLoading(false);
      }
    } catch (error) {
      console.error('Error creating product:', error);
      setFeedbackMessage('An error occurred while creating the product.');
      setFeedbackType('error'); // Set feedback type to error
      setLoading(false);
    }
  };

  return (
    <>
      <section className="">
        <div className="">
          <Grid container spacing={3} justifyContent="center">
            <Grid item xs={12}>
              {feedbackMessage && (
                <div
                  style={{
                    padding: "12px",
                    textAlign: "center",
                    borderRadius: "6px",
                    marginBottom: "12px",
                    backgroundColor: feedbackType === "success" ? "#D1FAE5" : "#FEE2E2", // green-100 / red-100
                    color: feedbackType === "success" ? "#047857" : "#B91C1C",           // green-700 / red-700
                  }}
                >
                  {feedbackMessage}
                </div>
              )}

              <div className="form-scroll-wrapper">

                <form
                  className="form-profile"
                  key={resetKey}
                  onSubmit={handleSubmit}
                >
                  <h2 className="text-2xl md:text-3xl font-bold headningfont text-center text-md-start mb-4 mt-3 mt-md-0">
                    Add New Product
                  </h2>

                  <Grid container spacing={3}>
                    {/* COUNTRY */}
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                      <label className="mb-2 block font-semibold">
                        Country *
                      </label>
                      <Select
                        options={countryOptions}
                        placeholder="Select Country"
                        isSearchable
                        value={countryOptions.find(c => c.value === formData.country) || null}
                        // ✅ THIS shows flag + name in dropdown
                        formatOptionLabel={(option) => (
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <img
                              src={option.image}
                              alt={option.label}
                              style={{ width: '20px', marginRight: '10px' }}
                            />
                            {option.label}
                          </div>
                        )}

                        // ✅ THIS shows flag in selected value also
                        getOptionLabel={(option) => option.label}

                        onChange={(option) => {
                          setFormData((prev) => ({
                            ...prev,
                            country: option.value,
                            state: '',   // ✅ CLEAR STATE
                            city: ''     // ✅ CLEAR CITY
                          }));

                          setStates([]); // optional
                          setCities([]); // optional
                          fetchStates(option.value);
                        }}
                      />
                    </Grid>

                    {/* STATE */}
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                      <label className="mb-2 block font-semibold">
                        State *
                      </label>
                      <Select
                        options={stateOptions}
                        placeholder="Select State"
                        isSearchable

                        value={stateOptions.find(s => s.value === formData.state) || null} // ✅ ADD THIS

                        onChange={(option) => {
                          setFormData((prev) => ({
                            ...prev,
                            state: option ? option.value : '',
                            city: '' // ✅ CLEAR CITY
                          }));

                          setCities([]); // optional

                          if (option) fetchCities(option.value);
                        }}
                      />
                    </Grid>

                    {/* CITY */}
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                      <label className="mb-2 block font-semibold">
                        City *
                      </label>
                      <Select
                        options={cityOptions}
                        placeholder="Select City"
                        isSearchable

                        value={cityOptions.find(c => c.value === formData.city) || null} // ✅ ADD THIS

                        onChange={(option) =>
                          setFormData((prev) => ({
                            ...prev,
                            city: option ? option.value : ''
                          }))
                        }
                      />
                    </Grid>

                    {/* MAIN SELECTION */}
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                      <label className="mb-2 block font-semibold">
                        Main Selection *
                      </label>
                      {/* <Select
                        options={selectionOptions}
                        placeholder="Select Selection"
                        isSearchable
                        onChange={(option) => {
                          setFormData((prev) => ({
                            ...prev,
                            selection: option.value,
                          }));
                          setSelectedSelection(option.value);
                        }}
                      /> */}

                      <Select
                        options={selectionOptions}
                        placeholder="Select Selection"
                        isSearchable

                        formatOptionLabel={(option) => (
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <img
                              src={option.image}
                              style={{ width: '20px', marginRight: '10px' }}
                            />
                            {option.label}
                          </div>
                        )}

                        onChange={(option) => {
                          setFormData((prev) => ({
                            ...prev,
                            selection: option.value,
                          }));
                          setSelectedSelection(option.value);
                        }}
                      />
                    </Grid>

                    {/* CATEGORY */}
                    {[1, 2, 3, 4, 5, 8].includes(selectedSelection) && (
                      <Grid item xs={12} sm={12} md={6} lg={6}>
                        <label className="mb-2 block font-semibold">
                          Category *
                        </label>
                        {/* <Select
                          options={categoryOptions}
                          placeholder="Select Category"
                          isSearchable
                          isLoading={isCategoriesLoading}
                          onChange={(option) =>
                            setFormData((prev) => ({
                              ...prev,
                              category: option.value,
                            }))
                          }
                        /> */}

                        <Select
                          options={categoryOptions}
                          placeholder="Select Category"
                          isSearchable
                          isLoading={isCategoriesLoading}

                          formatOptionLabel={(option) => (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <img
                                src={option.image}
                                style={{ width: '20px', marginRight: '10px' }}
                              />
                              {option.label}
                            </div>
                          )}

                          onChange={(option) =>
                            setFormData((prev) => ({
                              ...prev,
                              category: option.value,
                            }))
                          }
                        />
                      </Grid>
                    )}

                    {/* SHOP FOR */}
                    {[1, 2, 3, 4, 5, 6, 7, 8].includes(
                      selectedSelection
                    ) && (
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                          <label className="mb-2 block font-semibold">
                            Shop For *
                          </label>
                          <Select
                            options={shopForOptionsMapped}
                            placeholder="Shop For"
                            isSearchable
                            isLoading={isShopForLoading}
                            onChange={(option) =>
                              setFormData((prev) => ({
                                ...prev,
                                shopFor: option.value,
                              }))
                            }
                          />
                        </Grid>
                      )}

                    {/* IMAGE UPLOAD */}
                    <Grid item xs={12}>
                      <label style={{ display: "block", fontWeight: 600 }}>
                        Product Images *
                      </label>
                      <br />
                      <label
                        style={{
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          padding: "12px",
                          textAlign: "center",
                          cursor: "pointer",
                          display: "inline-block",
                        }}
                      >
                        <input
                          type="file"
                          accept="image/png, image/jpeg, image/jpg"
                          style={{ display: "none" }}
                          multiple
                          onChange={handleFileChange}
                        />
                        <i
                          className="fa-solid fa-camera"
                          style={{ fontSize: "1.5rem", marginBottom: "8px", display: "block" }}
                        ></i>
                        <p style={{ fontSize: "0.75rem", color: "#6B7280" }}>Browse Files</p>
                      </label>

                      {/* PREVIEW */}
                      <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", marginTop: "12px" }}>
                        {imagePreviews.map((img, i) => (
                          <div
                            key={i}
                            style={{
                              position: "relative",
                              width: "96px",
                              height: "96px",
                              border: "1px solid #ccc",
                              borderRadius: "0.5rem",
                              overflow: "hidden",
                            }}
                          >
                            <img
                              src={img}
                              alt="preview"
                              style={{ width: "100%", height: "100%", objectFit: "cover" }}
                            />
                            <button
                              type="button"
                              onClick={() => handleRemoveImage(i)}
                              style={{
                                position: "absolute",
                                top: "4px",
                                right: "4px",
                                backgroundColor: "#DC2626",
                                color: "#fff",
                                width: "20px",
                                height: "20px",
                                borderRadius: "50%",
                                fontSize: "12px",
                                lineHeight: "20px",
                                textAlign: "center",
                                border: "none",
                                cursor: "pointer",
                              }}
                            >
                              ×
                            </button>
                          </div>
                        ))}
                        <p
                          style={{
                            fontSize: "12px",
                            color: "red",
                            marginTop: "4px",
                          }}
                        >
                          Image Type: (W: 800px, H: 1100px) PNG, JPEG, JPG
                        </p>
                      </div>
                    </Grid>

                    {/* DESCRIPTION */}
                    {/* <Grid item xs={12}>
                      <label className="mb-2 block font-semibold">
                        Description *
                      </label>
                      <ReactQuill
                        theme="snow"
                        value={content}
                        onChange={handleChange}
                        className=""
                      />
                    </Grid> */}

                    <Grid item xs={12}>
                      <label
                        style={{
                          marginBottom: "8px",
                          display: "block",
                          fontWeight: "600",
                        }}
                      >
                        Description <span style={{ color: "red" }}>*</span>
                      </label>

                      <div
                        style={{
                          height: "180px",
                          marginBottom: "20px",
                        }}
                      >
                        <ReactQuill
                          theme="snow"
                          value={content}
                          onChange={handleChange}
                          style={{
                            height: "90%",
                          }}
                        />
                      </div>
                    </Grid>
                    {/* SUBMIT */}
                    <Grid item xs={12} className="text-center frmbtnsrch text-md-start">
                      <button className="themebtn px-8 py-3 mt-5" disabled={loading}>
                        {loading ? "Publishing..." : "Publish"}
                      </button>
                    </Grid>
                  </Grid>
                </form>

              </div>
            </Grid>
          </Grid>
        </div>
      </section>
    </>
  );
}
